var render = function render(){
  var _vm$global$profile;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('dialog-scroll-lock', _vm._g(_vm._b({
    attrs: {
      "content-class": "fill-height",
      "value": _vm.value,
      "width": "500"
    }
  }, 'dialog-scroll-lock', _vm.$attrs, false), _vm.$listeners), [_c('error-dialog', {
    attrs: {
      "status": _vm.loadProductsStatus
    }
  }), _c('error-dialog', {
    attrs: {
      "status": _vm.selectStatus
    }
  }), _c('error-dialog', {
    attrs: {
      "status": _vm.selectCountryStatus
    }
  }), _c('error-dialog', {
    attrs: {
      "status": _vm.searchPrivateStatus
    }
  }), _vm.selected ? _c('dialog-scroll-lock', {
    attrs: {
      "width": "400",
      "value": true
    },
    on: {
      "input": function ($event) {
        _vm.selected = null;
      }
    }
  }, [_c('v-card', [_c('v-btn', {
    staticClass: "float-right mt-3 mr-3",
    attrs: {
      "icon": ""
    },
    on: {
      "click": function ($event) {
        _vm.selected = null;
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiClose)
    }
  })], 1), _c('v-card-title', {
    staticClass: "pa-4"
  }, [_vm._v("Specify amount")]), (_vm.order.n_giftcard_recipients || 1) > 1 ? _c('v-card-subtitle', {
    staticClass: "mt-n5 px-4 pb-6"
  }, [_vm._v(" This gift card will be sent to " + _vm._s(_vm._f("pl")(_vm.order.n_giftcard_recipients, 'recipient')) + " ")]) : _vm._e(), _c('v-card-subtitle', {
    staticClass: "px-4 mt-0"
  }, [_c('v-card', {
    staticClass: "float-right ml-4 mb-1 gc-border",
    attrs: {
      "width": "100"
    }
  }, [_c('v-img', {
    attrs: {
      "aspect-ratio": 337 / 213,
      "src": _vm.selected.img
    }
  })], 1), _c('div', {
    staticClass: "overline short",
    staticStyle: {
      "color": "rgba(0, 0, 0, 0.87)"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.selected.name)
    }
  }), _c('giftcard-details', {
    attrs: {
      "src": _vm.selected.src,
      "product-id": _vm.selected.id
    }
  })], 1), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _c('div', {
    staticClass: "px-4 pb-4",
    class: {
      'pt-4': _vm.selected.values.fixed
    }
  }, [_c('v-form', {
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return function () {
          return _vm.amtValid && _vm.select();
        }.apply(null, arguments);
      }
    },
    model: {
      value: _vm.amtValid,
      callback: function ($$v) {
        _vm.amtValid = $$v;
      },
      expression: "amtValid"
    }
  }, [_c('giftcard-amount', {
    attrs: {
      "cur": _vm.selected.cur,
      "allowed-values": _vm.selected.values,
      "max": _vm.maxValue
    },
    model: {
      value: _vm.amt,
      callback: function ($$v) {
        _vm.amt = $$v;
      },
      expression: "amt"
    }
  })], 1)], 1), _vm.noAmtValid ? [_c('v-divider'), _c('v-card-text', {
    staticClass: "error--text font-italic pa-4"
  }, [_vm._v("Max gift card value is restricted to "), _c('currency', {
    attrs: {
      "code": _vm.$options.filters.cur(_vm.country)
    }
  }), _vm._v(_vm._s(_vm.order.skin.max_giftcard_value || 500000) + " – there are no valid values that can be assigned to this gift card. Please try a different one.")], 1)] : _vm._e(), _vm.isCompleted ? [_c('v-divider'), _c('payment', {
    staticClass: "py-4 mx-auto",
    staticStyle: {
      "min-height": "414px"
    },
    attrs: {
      "passive-sign-in": "",
      "metadata": _vm.paymentMetadata
    },
    on: {
      "complete": function ($event) {
        _vm.$emit('reload');
        _vm.$emit('input', false);
      }
    }
  })] : _c('v-card-actions', {
    staticClass: "pb-4"
  }, [_c('v-spacer'), _c('v-btn', {
    on: {
      "click": function ($event) {
        _vm.selected = null;
      }
    }
  }, [_vm._v("Cancel")]), _c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": !_vm.amtValid
    },
    on: {
      "click": _vm.select
    }
  }, [_vm._v("Add to card")])], 1)], 2)], 1) : _vm._e(), _c('v-card', {
    staticClass: "d-flex flex-column fill-height"
  }, [_c('v-card-title', {
    staticClass: "flex-grow-0 pa-4 d-block"
  }, [_c('v-btn', {
    staticClass: "float-right mt-n1 mr-n1",
    attrs: {
      "icon": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('input', false);
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiClose)
    }
  })], 1), _c('div', [_vm._v("Add gift card")]), _c('div', {
    staticClass: "text-caption"
  }, [_c('a', {
    attrs: {
      "href": "/faq#how-do-gift-cards-work",
      "target": "_blank"
    }
  }, [_vm._v("How gift cards work")])])], 1), _c('v-divider', {
    staticClass: "flex-grow-0"
  }), _c('div', {
    staticClass: "flex-grow-0 pa-4"
  }, [_c('div', {
    staticClass: "d-flex align-center",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "dense": "",
      "rounded": "",
      "hide-details": "",
      "clearable": "",
      "label": "Search"
    },
    on: {
      "click:clear": function ($event) {
        _vm.searchText = '';
      }
    },
    model: {
      value: _vm.searchText,
      callback: function ($$v) {
        _vm.searchText = $$v;
      },
      expression: "searchText"
    }
  }), _c('v-menu', {
    attrs: {
      "offset-y": "",
      "max-height": "90%",
      "nudge-left": "10"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var on = _ref.on;
        return [_c('div', _vm._g({
          staticClass: "d-flex align-center ml-2",
          staticStyle: {
            "cursor": "pointer"
          }
        }, on), [_c('country-flag', {
          attrs: {
            "country": _vm.country
          }
        }), _c('v-icon', {
          domProps: {
            "innerHTML": _vm._s(_vm.mdiMenuDown)
          }
        })], 1)];
      }
    }])
  }, [_c('v-list', {
    attrs: {
      "dense": ""
    }
  }, _vm._l(_vm.SUPPORTED_COUNTRY_CODES, function (code) {
    return _c('v-list-item', {
      key: code,
      attrs: {
        "input-value": _vm.country == code
      },
      on: {
        "click": function ($event) {
          return _vm.selectCountry(code);
        }
      }
    }, [_c('country-flag', {
      staticClass: "my-n1 ml-n1 mr-2 flex-shrink-0",
      staticStyle: {
        "transform": "scale(.8)"
      },
      attrs: {
        "country": code
      }
    }), _c('v-list-item-title', {
      staticClass: "overline"
    }, [_vm._v(_vm._s(_vm._f("country-name")(code)))])], 1);
  }), 1)], 1)], 1)]), _vm.USER_COUNTRY != _vm.country ? _c('div', {
    staticClass: "flex-grow-0 caption font-italic warning--text px-4 pb-4"
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "small": "",
      "color": "warning"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiAlert)
    }
  }), _vm._v(" These gift cards can only be redeemed in " + _vm._s(_vm._f("country-name")(_vm.country)) + " ")], 1) : _vm._e(), _c('div', {
    staticClass: "flex-grow-1 overflow-y-auto px-4"
  }, [_vm.loadProductsStatus.pending ? _c('div', {
    staticClass: "fill-height d-flex justify-center align-center"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": ""
    }
  })], 1) : _vm.products.length ? [_c('v-row', _vm._l(_vm.filteredProducts, function (product) {
    return _c('v-col', {
      key: product.id,
      attrs: {
        "cols": "6"
      }
    }, [_c('v-card', {
      staticClass: "gc-border",
      attrs: {
        "dark": "",
        "hover": ""
      },
      on: {
        "click": function ($event) {
          _vm.selected = product;
        }
      }
    }, [_c('v-img', {
      attrs: {
        "aspect-ratio": 300 / 190,
        "src": product.img
      }
    })], 1), _c('div', {
      staticClass: "pt-1 overline short text-center"
    }, [_vm._v(_vm._s(product.name))])], 1);
  }), 1), _vm.filteredProducts.length ? _c('div', {
    staticClass: "mt-8 mb-3 caption"
  }, [_vm._v("The merchants represented are not sponsors of the rewards or otherwise affiliated with Ellacard. The logos and other identifying marks attached are trademarks of and owned by each represented company and / or its affiliates. Please visit each company’s website for additional terms and conditions.")]) : _c('div', {
    staticClass: "mt-5 caption"
  }, [_vm._v(" No gift cards found "), (_vm$global$profile = _vm.global.profile) !== null && _vm$global$profile !== void 0 && _vm$global$profile.admin ? _c('div', {
    staticClass: "mt-16"
  }, [_c('div', {
    staticClass: "caption font-italic mb-1"
  }, [_vm._v("Ellacard admins only")]), _c('v-btn', {
    attrs: {
      "small": ""
    },
    on: {
      "click": _vm.searchPrivate
    }
  }, [_vm._v("Search private gift cards…")])], 1) : _vm._e()])] : _vm._e()], 2)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }